import React from "react";
import "./tenure-product-story.css";

export function TenureProductStory(): React.JSX.Element {
  return (
    <>
      <section id="long-lease" className="tenure-product-section tenure-reveal">
        <p className="tenure-product-eyebrow">The long-term commitment</p>
        <h2>What happens after year ten?</h2>
        <p className="tenure-product-lede">
          A campus lease can run for 20–25 years or more. Over that period, rent
          and school income can move at different rates, facilities need
          reinvestment, and the assumptions made before opening have to survive
          changing enrolments.
        </p>
        <div className="tenure-product-grid">
          <article>
            <h3>Rent compounds</h3>
            <p>
              Small differences in annual increases become material over the
              full term.
            </p>
          </article>
          <article>
            <h3>The school evolves</h3>
            <p>
              Test enrolment, fees and operating costs through the opening years
              and beyond.
            </p>
          </article>
          <article>
            <h3>The building ages</h3>
            <p>
              Put renewal, replacement and end-of-lease obligations on the
              agenda. Check which costs are included in each analysis.
            </p>
          </article>
          <article>
            <h3>The owner may change</h3>
            <p>
              Understand the developer’s exit assumptions alongside the school’s
              continuing commitment.
            </p>
          </article>
        </div>
        <p className="tenure-product-cta">
          <a href="/resources/lease-horizon-check.html">
            Try the free rent exposure check
          </a>
        </p>
        <p className="tenure-product-helper">
          Compare face and effective rent, annual reviews and incentive erosion
          over your chosen term. No sign-in required.
        </p>
      </section>

      <section
        id="specialists"
        className="tenure-product-section tenure-reveal"
      >
        <p className="tenure-product-eyebrow">Built from the ground up</p>
        <h2>By education real estate transaction specialists.</h2>
        <p className="tenure-product-proof">$500m+</p>
        <p className="tenure-product-proof-caption">
          in completed education real estate transactions behind the team.
        </p>
        <p className="tenure-product-lede">
          The model brings together the questions that arise in a campus
          transaction: the cost plan, the proposed rent, the catchment, the
          school’s operating assumptions and the developer’s return.
        </p>
      </section>

      <section id="outputs" className="tenure-product-section tenure-reveal">
        <p className="tenure-product-eyebrow">
          Take the analysis into the room
        </p>
        <h2>Detailed workbooks. Clear board reports.</h2>
        <div className="tenure-product-output-grid">
          <article>
            <h3>Microsoft Excel workbooks</h3>
            <p>
              Formula-driven schedules for development costs, operating cash
              flow, rent analysis, debt and sensitivities.
            </p>
          </article>
          <article>
            <h3>PDF decision reports</h3>
            <p>
              Present the proposal, assumptions, catchment context, scenario
              comparisons and unresolved questions in a structured report.
            </p>
          </article>
        </div>
        <p className="tenure-product-lede">
          Use construction benchmarks by school specification, with demographic
          context to inform discussion of enrolment and fees. Project-specific
          evidence and assumptions remain visible.
        </p>
        <p className="tenure-product-markets">
          Active market: Australia. Coming soon: New Zealand and Singapore.
        </p>
      </section>
    </>
  );
}
